import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import moment from 'moment';
import { MY_FORMATS } from '../../../../../../shared/constants/date.const';
import { isMasked, formatNumbers } from '../../../../../../shared/utils/functions';

@Component({
  selector: 'sp-input-fields',
  templateUrl: './input-fields.component.html',
  styleUrls: ['./input-fields.component.scss'],
  standalone: false,
})
export class InputFieldsComponent implements OnInit, OnDestroy {
  @Input() overlayFormControl: UntypedFormControl;
  _dropdownOptions = [];
  @Input() set optionValues(opts: { [key: string]: string }[]) {
    if (opts != null) {
      this._dropdownOptions = [{ key: null, value: '--' }, ...opts];
    }
  }
  get optionValues() {
    return this._dropdownOptions;
  }

  @Input() value: any;
  @Input() inputType: string;
  @Output() emitNumericData: EventEmitter<UntypedFormControl> = new EventEmitter();

  ngOnInit() {
    if (!isMasked(this.value)) {
      const val = this.inputType === 'date' && this.value ? moment(this.value, MY_FORMATS) : this.value;
      this.overlayFormControl.setValue(val);
    } else {
      this.inputType = 'masked';
      this.overlayFormControl.setValue(this.value);
    }
  }

  formatNumericData() {
    const digitalInfo = this.getDigitalInfo(this.inputType);
    const val = formatNumbers(this.overlayFormControl.value, digitalInfo);
    this.overlayFormControl.setValue(val);
    this.emitNumericData.emit(this.overlayFormControl);
  }

  private getDigitalInfo(inputType: string): string {
    const digitalInfoMap: Record<string, string> = {
      numeric: '.0-2',
      currency: '.2-2',
    };
    return digitalInfoMap[inputType] ?? '.0-0';
  }

  ngOnDestroy() {
    // required by angular-l10n
  }
}
